import { create } from 'zustand';
import type { Deal } from './types';

/** Tipo de transição crítica que exige comentário obrigatório (DOCUMENTACAO.md §6.3). */
export type CriticalKind = 'discard' | 'reactivate' | 'retorno';

/**
 * Estado global do modal de transição crítica (descarte / reativação / retorno de fase).
 * Global (zustand) porque é acionado de lugares diferentes: o drag-para-trás no kanban, o
 * stepper da ficha e os botões Descartar/Reativar da ficha. O `<CriticalTransitionModal/>` é
 * renderizado uma vez e lê esta store.
 */
interface CriticalTransitionState {
  open: boolean;
  kind: CriticalKind;
  deal: Deal | null;
  /** apiName da fase de destino — só para 'retorno'. */
  targetStage: string | null;
  openDiscard: (deal: Deal) => void;
  openReactivate: (deal: Deal) => void;
  openRetorno: (deal: Deal, targetStage: string) => void;
  close: () => void;
}

export const useCriticalTransition = create<CriticalTransitionState>()((set) => ({
  open: false,
  kind: 'discard',
  deal: null,
  targetStage: null,
  openDiscard: (deal) => set({ open: true, kind: 'discard', deal, targetStage: null }),
  openReactivate: (deal) => set({ open: true, kind: 'reactivate', deal, targetStage: null }),
  openRetorno: (deal, targetStage) => set({ open: true, kind: 'retorno', deal, targetStage }),
  close: () => set({ open: false, deal: null, targetStage: null }),
}));
